import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVoiceAssTableCard,
	XVSLottieWrapper,
	XVSLottie,
} from '../../VoiceAssistanceStyle';
import { Row, Col, notification } from 'antd';
import VSLoaderJson from '../../../../json/loader.json';
import VSdotsAnimation from '../../../../json/dotsAnimation.json';

import {
	getAnalysisStatusApi,
	getAnalysisStatusReset,
} from '../../../../actions/getAnalysisStatusAction';

const VAAnalysisLoader = (props) => {
	const {
		getAnalysisStatus,
		getAnalysisStatusState,
		getAnalysisStatusReset,
		analysisId,
		analysisCompleted,
		setAnalysisCompleted,
		setLoading,
		loading,
		isMissingFieldsThere,
		setIsMissingFieldsThere,
		setCurrentView,
	} = props;

	const [shouldCheckStatus, setShouldCheckStatus] = useState(false);
	const [statusNumber, setStatusNumber] = useState(0);
	const [status6Visible, setStatus6Visible] = useState(false);
	const [statusList, setStatusList] = useState([
		{
			key: 1,
			title: 'Analysing Medical Documents',
			icon: '/images/loader-icon1.svg',
			class: 'inprocess',
			visible: true,
			status: false,
		},
		{
			key: 2,
			title: 'Mapping Diagnosis Codes',
			icon: '/images/loader-icon2.svg',
			class: 'inprocess',
			visible: true,
			status: false,
		},
		{
			key: 3,
			title: 'Mapping Procedural Codes',
			icon: '/images/loader-icon3.svg',
			class: 'inprocess',
			visible: true,
			status: false,
		},
		{
			key: 4,
			title: 'Determining Insurance Coverage',
			icon: '/images/loader-icon4.svg',
			class: 'inprocess',
			visible: true,
			status: false,
		},
		{
			key: 5,
			title: 'Checking Missing Inclusion Criteria',
			icon: '/images/loader-icon5.svg',
			class: 'inprocess',
			visible: true,
			status: false,
		},
		{
			key: 6,
			title: 'Generating Results',
			icon: '/images/loader-icon6.svg',
			class: 'inprocess',
			visible: false,
			status: false,
		},
	]);

	useEffect(() => {
		if (shouldCheckStatus) {
			setStatusList((oldList) => {
				oldList.forEach((item) => {
					if (item.key === 6) {
						// Only show and update status 6 after statuses 1-5 are complete
						if (
							statusNumber === 6 &&
							analysisCompleted !== 'error'
						) {
							item.visible = true;
							item.class = 'inprocess';
							setStatus6Visible(true);
						}
					} else if (
						item.key === 1 &&
						analysisCompleted === 'error'
					) {
						item.class = 'inprocess';
						item.status = true;
					} else if (analysisCompleted === 'error') {
						item.class = 'inprocess';
						item.status = false;
					} else if (analysisCompleted === 'success') {
						item.class = 'active';
						item.status = true;
					} else if (
						item.key <= statusNumber &&
						!['success', 'error'].includes(analysisCompleted)
					) {
						item.class = 'active';
						if (!item.status) item.status = true;
					} else if (
						item.key === statusNumber + 1 &&
						!['success', 'error'].includes(analysisCompleted)
					) {
						item.class = 'inprocess';
						if (!item.status) item.status = true;
					}
				});
				return oldList;
			});
		}
	}, [statusNumber, shouldCheckStatus]);

	useEffect(() => {
		let updateStatusEvent;
		if (
			statusNumber <= statusList.length + 1 &&
			!['success', 'error'].includes(analysisCompleted)
		) {
			updateStatusEvent = setInterval(() => {
				// getAnalysisStatusReset();
				getAnalysisStatus({ id: analysisId });
			}, 5000);
		}
		getAnalysisStatusReset();

		return () => {
			if (updateStatusEvent) clearInterval(updateStatusEvent);
		};
	}, [statusNumber]);

	useEffect(() => {
		if (
			getAnalysisStatusState.apiState == 'success' &&
			getAnalysisStatusState.data
		) {
			setStatusNumber(getAnalysisStatusState.data.status);
			// Set flag to true after the API response updates the status
			setShouldCheckStatus(true);
		}
	}, [getAnalysisStatusState.apiState]);

	useEffect(() => {
		if (analysisCompleted === 'success') {
			if (!isMissingFieldsThere) {
				let stepDelay = 1000; // Delay between steps in milliseconds
				let finalDelay = 3000; // Delay after the last step in milliseconds
				let stepIndex = statusNumber;

				const stepInterval = setInterval(() => {
					stepIndex++;
					setStatusNumber(stepIndex);

					if (stepIndex >= statusList.length) {
						clearInterval(stepInterval);
						setTimeout(() => {
							setLoading(false); // Wait after the last step
							setCurrentView('case-details');
						}, finalDelay);
					}
				}, stepDelay);
			} else {
				setIsMissingFieldsThere(false);
				setLoading(false); // Stop at the current stage
				setCurrentView('case-details');
			}
		} else if (analysisCompleted === 'error') {
			setIsMissingFieldsThere(false);
			setLoading(false);
			setCurrentView('case-details');
		}

		setIsMissingFieldsThere(false);
		setAnalysisCompleted('');
	}, [analysisCompleted]);

	useEffect(() => {
		setStatusList((oldList) => {
			return oldList.map((item) => ({
				...item,
				class: 'inprocess',
				status: false,
				visible: item.key !== 6, // Keep status 6 hidden initially
			}));
		});
		setStatusNumber(0); // Reset status number on loading
	}, [loading]);

	useEffect(() => {
		let timer;
		if (status6Visible) {
			timer = setTimeout(() => {
				setStatusList((prevList) =>
					prevList.map((statusItem) =>
						statusItem.key === 6
							? { ...statusItem, class: 'active', status: true }
							: statusItem,
					),
				);
			}, 2000);
		}

		return () => {
			if (timer) clearTimeout(timer);
		};
	}, [status6Visible]);

	return (
		<XThemeVSSetViewPort className="displyBlock">
			<XThemeVSScrollContainer>
				<Row gutter={[15, 15]}>
					<Col xs={24}>
						<XThemeVoiceAssTableCard>
							<div className="hasPadding">
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xs={24} className="text-center">
										<XVSLottieWrapper>
											<XVSLottie
												animationData={VSLoaderJson}
												loop={true}
											/>
											<div className="innerCard">
												<ul>
													{statusList.map((item) =>
														item.visible ? (
															<li
																key={item.key}
																className={
																	item.class
																}
															>
																<span>
																	<img
																		width="15px"
																		src={
																			item.icon
																		}
																		alt={`Step ${item.key}`}
																	/>
																</span>
																{item.title}
																<span className="status-icon">
																	{item.class ===
																		'active' &&
																		item.status ===
																			true && (
																			<img
																				width="15px"
																				src="/images/check.svg"
																				alt="Completed"
																			/>
																		)}
																	{item.class ===
																		'inprocess' && (
																		<XVSLottie
																			animationData={
																				VSdotsAnimation
																			}
																			loop={
																				true
																			}
																		/>
																	)}
																</span>
															</li>
														) : (
															<React.Fragment
																key={item.key}
															></React.Fragment>
														),
													)}
												</ul>
											</div>
										</XVSLottieWrapper>
									</Col>
								</Row>
							</div>
						</XThemeVoiceAssTableCard>
					</Col>
				</Row>
			</XThemeVSScrollContainer>
		</XThemeVSSetViewPort>
	);
};

const mapStateToProps = (state) => ({
	getAnalysisStatusState: state.getAnalysisStatus,
});

const mapDispatchToProps = (dispatch) => ({
	getAnalysisStatus: (params) => dispatch(getAnalysisStatusApi(params)),
	getAnalysisStatusReset: () => dispatch(getAnalysisStatusReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VAAnalysisLoader);
